import { render, staticRenderFns } from "./ConveyanceInsurance.vue?vue&type=template&id=7be122c6&scoped=true"
import script from "./ConveyanceInsurance.vue?vue&type=script&lang=js"
export * from "./ConveyanceInsurance.vue?vue&type=script&lang=js"
import style0 from "./ConveyanceInsurance.vue?vue&type=style&index=0&id=7be122c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be122c6",
  null
  
)

export default component.exports